import { Form, Formik } from "formik";
import Button from "../../../Components/Button/Button";
import validations from "../../../Utils/Validations/Validations";
import { usePagination, useSortBy, useTable } from "react-table";
import { useEffect, useState, useRef } from "react";
import PaginationComponent from "../../../Components/PaginationTableServer/PaginationTableServer";
import Exports from "../../../Components/Exports/Exports";
import SelectCheckField from "../../../Components/SelectCheckField/SelectCheckField";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import notfound from "../../../Assets/images/il-empty.svg";
import { ObtenerPeriodosInformeConservacion } from "../Services/ObtenerPeriodosInformeConservacion";
import ModalInforme from "./ModalInforme";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import useLogin from "../../Autenticacion/Hooks/useLogin";
import Accordion from "react-bootstrap/Accordion";
import { useNavigate } from "react-router-dom";
import { useInformesConservacion } from "../../Informes/Hooks/useInformesConservacion";
import { AutorizarInformeConservacion } from "../Services/AutorizarInformeConservacion";
import { useToast } from "../../../Hooks/useToast";

const CustomToggle = ({ children, eventKey, sigla }) => {
	const decoratedOnClick = useAccordionButton(eventKey, () => null);

	return (
		<button
			className="accordion-toggle"
			type="button"
			onClick={decoratedOnClick}
		>
			<i className="ico-chevron-down"></i>
			<span className="fw-semibold">{sigla}</span>
		</button>
	);
};

const TablaInformes = ({ columns, data, fetchData, pageCount: controlledPageCount, currentpage, pageSize: controlledPageSize, sortBy: controlledSortBy, setPagination, tab}) => {
	const {getTableProps, getTableBodyProps, headerGroups, pageCount ,gotoPage ,state: { pageIndex, pageSize, sortBy }} = useTable({
		columns,
		data,
		initialState: {pageIndex: currentpage, pageSize: controlledPageSize, sortBy: controlledSortBy},
		manualPagination: true,
		pageCount: controlledPageCount,
		autoResetPage: false,
		autoResetSortBy: false,
		manualSortBy: true,
		},useSortBy, usePagination );
	const [showModal, setShowModal] = useState(false);
	const [datosModal, setDatosModal] = useState({esIndicador: false, esAutorizado: ""});
	const formikRef = useRef();
	const [autorizar, setAutorizar] = useState();
	const [autorizado, setAutorizado] = useState(false);
	const [botonModal,setBotonModal] = useState(false);
	const [informeConservacionId, setInformeConservacionId] = useState([]);
	const { usuario } = useLogin();
	const [listadoIndicadoresId, setListadoIndicadoresId] = useState([]);
	const [listadoExigenciasId, setListadoExigenciaId] = useState([]);
	const [primeraCarga, setPrimeraCarga] = useState(true);
	const [listadoInformes, setListadoInformes] = useState(true)
	const [periodo, setPeriodo] = useState([]);
	const [leerFiltros, setLeerFiltros] = useState(false)
	const [trimestresInformados, setTrimestresInformados] = useState([]);
	const [años, setAños] = useState([]);
	const [cambiarPagina, setCambiarPagina] = useState(false);
	const navigate = useNavigate();
	const addToast = useToast();
	const {	postObtenerEstadoAutorizacion, listaEstadoAutorizacion,	postObtenerIndicadores,	indicadorTotal} = useInformesConservacion();

	const [valoresFormularioEnvio, setValoresFormularioEnvio] = useState({
		paginacion: {
			numeroPagina: pageIndex,
			cantidadRegistros: pageSize,
			orderByAscending: false,
			ordenadoPor: ""
		},
		datosBuscar: {
			usuarioId: usuario.id,
			indicadorId: listadoIndicadoresId,
			exigenciaId: listadoExigenciasId,
			estadoAutorizacion: listaEstadoAutorizacion,
			ano: años,
			trimestre: trimestresInformados,
			exportacion: false
		},
	});

	const [initialValues, setInitialValues] = useState({
		indicador_conservacion: "",
		exigencia_indicador: "",
		estado: "",
		trimestre_informados: "",
		año_infome: ""
	});

	const descargar = () => {
		fetchData({ formulario: valoresFormularioEnvio, pageIndex: pageIndex,sortBy, exportacion: true});
	};

	const Modificar = (esAutorizado, informeConservacionId) => {
		setDatosModal({ esIndicador: false, esAutorizado });
		setShowModal(true);
		setInformeConservacionId(informeConservacionId);
	};

	const handleIndicadorChange = (selectedIds) => {
		const exigenciasFiltradas = indicadorTotal
			.filter((indicador) => selectedIds.includes(indicador.indicadorId))
			.flatMap((indicador) =>
				indicador.exigencias.map((exigencia) => ({
					value: exigencia.id,
					label: `${indicador.sigla} - ${exigencia.sigla} - ${exigencia.descripcion}`,
				}))
			);
		setListadoExigenciaId(exigenciasFiltradas);
	};

	const handleAñoChange = (selectedAños, setFieldValue) => {
		const trimestresFiltrados = [
			...new Map(
				periodo
					.filter((p) => selectedAños.includes(p.año))
					.flatMap((p) =>
						p.trimestres.map((trimestre) => ({
							value: trimestre.id,
							label: trimestre.descripcion,
						}))
					)
					.map((trimestre) => [trimestre.value, trimestre])
			).values(),
		];

		setTrimestresInformados(trimestresFiltrados);
		setFieldValue("año_infome", selectedAños);
	};

	const hideModal = () => {
		setShowModal(false);
	};

	function BuscarAutorizaciones(values) {
		const valor = {
			paginacion: {
				numeroPagina: pageIndex,
				cantidadRegistros: pageSize,
				orderByAscending:
					sortBy.length > 0
						? !sortBy[0].desc
						: valoresFormularioEnvio.paginacion.orderByAscending,
				ordenadoPor:
					sortBy.length > 0
						? sortBy[0].id
						: valoresFormularioEnvio.paginacion.ordenadoPor,
			},
			datosBuscar: {
				usuarioId: usuario.id,
				indicadorId: values.indicador_conservacion,
				exigenciaId: values.exigencia_indicador,
				estadoAutorizacion: values.estado,
				ano: values.año_infome,
				trimestre:
					values.trimestre_informados === ""
						? null
						: values.trimestre_informados,
				exportacion: false,
			},
		};
		setValoresFormularioEnvio(valor);
		fetchData({ formulario: valor, pageIndex, sortBy });
	}

	async function postObtenerPeriodos() {
		const usuarioId = usuario.id;
		const resultado = await ObtenerPeriodosInformeConservacion(usuarioId);
		if (resultado.status === 200) {
			setPeriodo(resultado.data);
		}
	}

	async function postAutorizarInformeConservacion() {
		const usuarioId = {
			usuarioId: usuario.id,
			informeConservacionId: informeConservacionId,
            autorizar: autorizar,
		};

		const resultado = await AutorizarInformeConservacion(usuarioId);
		if (resultado.status === 200) {
			addToast({ mostrar: true, mensaje: "Informe Actualizado Correctamente", titulo: 'Información', tipo: 'Info' });
			setAutorizado(true)
		}
	}

	useEffect(() => {
		if (primeraCarga && listadoIndicadoresId.length > 0 && listaEstadoAutorizacion.length > 0) {
			setInitialValues((values) => ({
				...values,
				indicador_conservacion: listadoIndicadoresId.map((x) => x.value),
				exigencia_indicador: listadoExigenciasId.map((x) => x.value),
				estado: listaEstadoAutorizacion.map((x) => Number(x.value)),
				trimestre_informados: trimestresInformados.map((x) => Number(x.value)),
				año_infome: años.map((x) => Number(x.value))
			}));
			setPrimeraCarga(false);
			setLeerFiltros(true);
		}
	}, [listadoIndicadoresId, listadoExigenciasId, listaEstadoAutorizacion, periodo, trimestresInformados, años]);

	useEffect(() => {
		if (periodo.length > 0) {
			setInitialValues((values) => ({
				...values,
				trimestre_informados: trimestresInformados.map((x) => Number(x.value)),
				año_infome: años.map((x) => Number(x.value))
			}));
			setLeerFiltros(true);
		}
	}, [periodo, trimestresInformados, años]);

	useEffect(() => {
		if (
			leerFiltros && 
			initialValues.indicador_conservacion.length > 0 &&
			initialValues.exigencia_indicador.length > 0 &&
			initialValues.estado.length > 0 &&
			initialValues.año_infome.length > 0 
		) {
			setValoresFormularioEnvio((prev) => ({
				...prev,
				datosBuscar: {
					...prev.datosBuscar,
					indicadorId: initialValues.indicador_conservacion,
					exigenciaId: initialValues.exigencia_indicador,
					estadoAutorizacion: initialValues.estado,
					ano: initialValues.año_infome,
					trimestre: initialValues.trimestre_informados,
				},
			}));
			setLeerFiltros(false);
		}
	}, [initialValues, leerFiltros]);

	useEffect(() => {
		const indicadores = indicadorTotal.map((x) => ({
			value: x.indicadorId,
			label: `${x.sigla}`,
		}));
		setListadoIndicadoresId(indicadores);

		const exigencias = indicadorTotal.flatMap((indicador) =>
			indicador.exigencias.map((exigencia) => ({
				value: exigencia.id,
				label: `${indicador.sigla} - ${exigencia.sigla} - ${exigencia.descripcion}`,
			}))
		);
		setListadoExigenciaId(exigencias);
	}, [indicadorTotal]);

	useEffect(() => {
		if (periodo.length > 0) {
			const trimestresUnicos = [
				...new Map(
					periodo
						.flatMap((p) =>
							p.trimestres.map((trimestre) => ({
								value: trimestre.id,
								label: trimestre.descripcion,
							}))
						)
						.map((trimestre) => [trimestre.value, trimestre])
				).values(),
			];
			setTrimestresInformados(trimestresUnicos);

			const listaAños = periodo.map((p) => ({
				value: p.año,
				label: `${p.año}`,
			}));
			setAños(listaAños);
		}
	}, [periodo]);

	useEffect(() => {
		if (tab === 'informes')
		{
			postObtenerIndicadores(usuario.id);
			postObtenerEstadoAutorizacion(usuario.id);
			postObtenerPeriodos();
		}
	}, [usuario.id, tab]);

	useEffect(() => {
		if (tab === 'informes')
		{
			if (valoresFormularioEnvio.datosBuscar.indicadorId.length > 0 && listadoInformes && !cambiarPagina) {
				fetchData({ formulario: valoresFormularioEnvio, pageIndex, sortBy });
				setPagination((values) => ({
					...values,
					sortBy: sortBy,
				}));
				setListadoInformes(false)
				setCambiarPagina(true)
			}
	
			if (autorizado) {
				fetchData({ formulario: valoresFormularioEnvio, pageIndex, sortBy });
				setPagination((values) => ({
					...values,
					sortBy: sortBy,
				}));
				setAutorizado(false);
				setCambiarPagina(true)
			}
		}
		
		if (tab !== 'informes') {
			setListadoInformes(true);
			setCambiarPagina(false)
		}	
	}, [valoresFormularioEnvio, autorizado, tab]);

	useEffect(() => {
			if (cambiarPagina) {
			fetchData({ formulario: valoresFormularioEnvio, pageIndex, sortBy });
			setPagination((values) => ({
				...values,
				sortBy: sortBy,
			}));
		}
	}, [pageIndex, sortBy])

	useEffect(() => {
		if(botonModal)
		{
			postAutorizarInformeConservacion();
			setBotonModal(false);
		}
	}, [botonModal])

	return (
		<>
			<div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center mb-5 gap-3">
				<Formik
					innerRef={formikRef}
					enableReinitialize
					initialValues={initialValues}
					validate={validations}
					onSubmit={(values) => {
						BuscarAutorizaciones(values);
					}}
				>
					{({ setFieldTouched, setFieldValue }) => (
						<Form className="form mb-0">
							<div className="tools order-1 order-lg-0 align-items-start">
								<SelectCheckField
									name="indicador_conservacion"
									label="Indicador"
									options={listadoIndicadoresId}
									onBlur={setFieldTouched}
									onChange={(e, value) => {
										handleIndicadorChange(value);
										setFieldValue("indicador_conservacion", value);
									}}
									isMulti={true}
								/>
								<SelectCheckField
									name="exigencia_indicador"
									label="Exigencia"
									options={listadoExigenciasId}
									onBlur={setFieldTouched}
									onChange={setFieldValue}
									isMulti={true}
								/>
								<SelectCheckField
								    name="estado"
					                label='Estado Autorización IF'
									options={listaEstadoAutorizacion}
									onBlur={setFieldTouched}
									onChange={setFieldValue}
									isMulti={true}
								/>
								<SelectCheckField
									name="año_infome"
									label="Año"
									options={años}
									onBlur={setFieldTouched}
									onChange={(e, value) => handleAñoChange(value, setFieldValue)} // Maneja el cambio de año
									isMulti={true}
								/>
								<OverlayTrigger
									placement="top"
									overlay={
										<Tooltip id="tooltip-top">
											Filtro no aplica para el indicador PAV dado que es anual
										</Tooltip>
									}
								>
									<div>
										<SelectCheckField
											name="trimestre_informados"
											label="Trimestre"
											options={trimestresInformados}
											onBlur={setFieldTouched}
											onChange={setFieldValue}
											isMulti={true}
										/>
									</div>
								</OverlayTrigger>
								<Button type="submit" design="btn-primary">
									Buscar
								</Button>
							</div>
						</Form>
					)}
				</Formik>
				{data.length > 0 && (
					<div className="exports order-0 order-lg-1">
						<Exports descargar={() => descargar()} />
					</div>
				)}
			</div>
			{data.length > 0 ? (
				Object.entries(
					data.reduce((acc, curr) => {
					const tipo = curr.tipo;
					if (!acc[tipo]) acc[tipo] = [];
					acc[tipo].push(curr);
					return acc;
					}, {})
				).map(([tipo, items]) => (
					<Accordion key={tipo} defaultActiveKey={tipo} className="accordion-table">
					<div className="accordion-item">
						<div className="accordion-header gap-4 py-2">
						<CustomToggle eventKey={tipo} sigla={tipo} />
						<div className="d-flex gap-2 ms-auto me-2">
							<button
							className="btn btn--outline btn--pewter-blue btn--xs"
							disabled={items.some(item => item.estadoAutorizacion !== "Pendiente")}
							onClick={() => Modificar("Autorizado", items.map(item => item.informeConservacionId))}
							>
							<i className="ico-check"></i>
							</button>
							<button
							className="btn btn--outline btn--pewter-blue btn--xs"
							disabled={items.some(item => item.estadoAutorizacion !== "Pendiente")}
							onClick={() => Modificar("Rechazado", items.map(item => item.informeConservacionId))}
							>
							<i className="ico-close"></i>
							</button>
						</div>
						</div>
						<Accordion.Collapse eventKey={tipo}>
						<div className="accordion-body p-0">
							<table className="table" {...getTableProps()}>
							<thead>
								{headerGroups.map((headerGroup) => {
								const { key: hgKey, ...hgProps } = headerGroup.getHeaderGroupProps();
								return (
								<tr key={hgKey} {...hgProps}>
									{headerGroup.headers.map((column) => {
										const { key: thKey, ...thProps } = column.getHeaderProps(column.getSortByToggleProps());
										return (
									<th key={thKey} {...thProps} className={column.className}>
										<span className="d-flex align-items-center gap-1">
										{column.render("Header")}
										{column.isSorted ? (
											column.isSortedDesc ? (
											<i className="ico-chevron-down"></i>
											) : (
											<i className="ico-chevron-up"></i>
											)
										) : (
											<i className="ico-sort fs-7"></i>
										)}
										</span>
									</th>
										);
									})}
								</tr>
								);
								})}
							</thead>
							<tbody {...getTableBodyProps()}>
								{items.length > 0 ? (
									items.map((item, rowIndex) => (
										<tr key={rowIndex}>
											{columns.map((column) => (
												<td key={column.accessor} className={column.headerClassName}>
												{column.accessor !== "acciones"
													? column.Cell 
														? column.Cell({ row: { original: item } })
														: item[column.accessor]
													: (
														<div className="d-flex justify-content-center gap-2">
														{item.estadoAutorizacion === "Pendiente" && (
																<>
																	<button
																		className="btn btn--outline btn--pewter-blue btn--xs"
																		onClick={() => Modificar("Autorizado", [item.informeConservacionId])}
																	>
																		<i className="ico-check"></i>
																	</button>
																	<button
																		className="btn btn--outline btn--pewter-blue btn--xs"
																		onClick={() => Modificar("Rechazado", [item.informeConservacionId])}
																	>
																		<i className="ico-close"></i>
																	</button>
																</>
															)}
															<button 
																className="link text-pewter-blue fs-4"
																onClick={() => navigate("/bitacora/eventos_concesion", { state: item })}
															>
																<i className="ico-search"></i>
															</button>
														</div>
													)
												}
											</td>										
											))}
										</tr>
									))
								) : (
									<tr>
										<td colSpan={columns.length}>
											<div className="d-flex justify-content-center align-items-center flex-column gap-2 py-5">
												<img className="mb-3" src={notfound} alt="No encontrado" />
												<p className="mb-0 text-primary">No se encuentran resultados de tu búsqueda.</p>
											</div>
										</td>
									</tr>
								)}
							</tbody>
							</table>
						</div>
						</Accordion.Collapse>
					</div>
					</Accordion>
				))
			) : (
				<div className="d-flex justify-content-center align-items-center flex-column gap-2 py-5">
					<img className="mb-3" src={notfound} alt="" />
					<p className="mb-0 text-primary">
						No se encuentran resultados de tu búsqueda.
					</p>
				</div>
			)}
			<ModalInforme
				show={showModal}
				onHide={hideModal}
				setAutorizar={setAutorizar}
				datosModal={datosModal}
				setBotonModal={setBotonModal}
			/>

			{data.length > 0 && (
				<PaginationComponent
					pagesCountServer={pageCount}
					currentPage={pageIndex}
					setCurrentPage={gotoPage}
					alwaysShown={false}
					setPagination={setPagination}
				/>
			)}
		</>
	);
};
export default TablaInformes;
